// src/helpers/rutaRemitos.js
import api, { apiGet, apiPost, apiPut, apiDelete } from "./api";

/** Lista de remitos */
export async function getRemitos(params = {}) {
  const q = new URLSearchParams(params).toString();
  const data = await apiGet(`/remitos${q ? "?" + q : ""}`);
  // si tu back devuelve {ok, remitos}, normalizo:
  return Array.isArray(data) ? data : data.remitos || [];
}

/** Remito por id */
export async function getRemitoById(id) {
  return apiGet(`/remitos/${id}`);
}

/** Crear remito */
export async function postRemito(payload) {
  try {
    // ruta nueva/clásica montada en /remitos
    return await apiPost(`/remitos`, payload);
  } catch (e) {
    // fallback por si en tu back la creación está en /remito
    if (e?.response?.status === 404) {
      return apiPost(`/remito`, payload);
    }
    throw e;
  }
}

/** Actualizar remito */
export async function putRemito(id, payload) {
  try {
    // ruta nueva/clásica montada en /remitos/:id
    return await apiPut(`/remitos/${id}`, payload);
  } catch (e) {
    // fallback por si en tu back la edición está en /remito/:id
    if (e?.response?.status === 404) {
      return apiPut(`/remito/${id}`, payload);
    }
    throw e;
  }
}

/** Borrado lógico si tu ruta lo soporta */
export async function deleteRemito(id) {
  try {
    return await apiDelete(`/remitos/${id}`);
  } catch (e) {
    if (e?.response?.status === 404) {
      return apiDelete(`/remito/${id}`);
    }
    throw e;
  }
}

/** Pendientes por proveedor (para OP Remitos) */
export async function getRemitosPendientesProveedor(proveedorId, clienteId) {
  const q = new URLSearchParams();
  if (clienteId) q.set("cliente", clienteId);

  const path = `/remitos/pendientes/proveedor/${proveedorId}${
    q.toString() ? "?" + q.toString() : ""
  }`;

  const data = await apiGet(path);
  return data?.pendientes || data || [];
}

/** ✅ Pendientes por cliente (para OC Remitos, Venta A/B) */
export async function getRemitosPendientesCliente(clienteId, proveedorId) {
  const q = new URLSearchParams();
  if (proveedorId) q.set("proveedor", proveedorId);

  const path = `/remitos/pendientes/cliente/${clienteId}${
    q.toString() ? "?" + q.toString() : ""
  }`;

  const data = await apiGet(path);
  return data?.pendientes || data || [];
}

// ✅ Crea remito con nro manual (SALDO INICIAL 1..100) sin tocar back.
// Estrategia:
// 1) POST /remitos con nroRemito manual
// 2) Si el back lo ignora y devuelve otro nro, intentamos PUT para fijarlo.// ✅ Crea remito con codrem manual (SALDO INICIAL 1..100) sin tocar back.
// Estrategia:
// 1) POST /remitos con codrem manual
// 2) Si el back lo ignora y devuelve otro codrem, intentamos PUT para fijarlo.
// src/helpers/rutaRemitos.js
// en src/helpers/rutaRemitos.js
export async function postRemitoSaldoInicial(payload) {
  const nro = Number(payload?.codrem);

  if (!Number.isFinite(nro) || nro < 1 || nro > 100) {
    throw new Error("El nro de remito manual debe estar entre 1 y 100.");
  }

  // 1) Creo
  const r = await postRemito(payload);

  // Si el back responde 200 con ok:false
  if (r?.ok === false) {
    const msg = r?.err?.message || r?.msg || "El back devolvió ok:false.";
    throw new Error(msg);
  }

  const remito = r?.remito || r;
  const id = remito?._id || remito?.id;
  const nroDevuelto = Number(remito?.codrem ?? NaN);

  // 2) Si vino bien, listo
  if (id && nroDevuelto === nro) return r;

  // 3) Intento corregir con PUT (esto SOLO funciona si el back lo permite)
  if (id && nroDevuelto !== nro) {
    try {
      const u = await putRemito(id, { codrem: nro });
      if (u?.ok === false) throw new Error(u?.err?.message || u?.msg || "PUT devolvió ok:false");
      return await getRemitoById(id);
    } catch (e) {
      throw new Error(
        "El back está pisando 'codrem' (Counter / immutable / validación). " +
        "Para poder usar 1..100 de forma real, hay que habilitarlo en el backend."
      );
    }
  }

  return r;
}
